module.exports = __webpack_public_path__ + "static/media/service-1.bae382d7.jpg";